import { Pagination } from '@eb/antd';
import React from 'react';
import { I18N } from './I18N';

const EBPagination = (props) => {
  const customSelect = (selectProps) => {
    const { className, children, onChange, value } = selectProps
    return (
      <div>
        <label htmlFor="paginationSelector" className="sr-only">
          <I18N>pagination.list.quantity.selector</I18N>
        </label>
        <select
          id="paginationSelector"
          className={`${className} rounded`}
          onChange={e => onChange(e.target.value)}
          value={value}
        >
          {children}
        </select>
      </div>
    )
  };
  customSelect.Option = ({ children, value }) => <option value={value}>{children}</option>;

  return (
    <div>
      <Pagination
        showTitle={false}
        showSizeChanger
        pageSizeOptions={[10, 25, 50, 100, 200]}
        selectComponentClass={customSelect}
        {...props}
      />
    </div>
  )
}

export default EBPagination;
